import { COUPON_SERVICE_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";

import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import AxiosCurlirize from "axios-curlirize";

export interface ICouponserviceSubCategoryResponseData {
  subcategory_id: string;
  subcategory_name: string;
  is_medicine: boolean;
}
export interface ICouponserviceSubCategoryResponse {
  status: boolean;
  message: string;
  data: ICouponserviceSubCategoryResponseData[];
}

AxiosCurlirize(axios, () => {});
type InventoryTaxCreateAPIResponse = { status: boolean; message: any };

export const useCouponSubCategoryAPI = () => {
  const [serviceSubCategory, setServiceSubCategory] = useState<ICouponserviceSubCategoryResponseData[]>([]);
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();
  const appendInResult = (data: ICouponserviceSubCategoryResponseData) => {
    setServiceSubCategory((prev) => [...prev, data]);
  };

  const execute = useCallback(
    async (category_ids: string | string[]) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const categoryIdsParam = Array.isArray(category_ids) ? category_ids.join(",") : category_ids;
        const response: InventoryTaxCreateAPIResponse = await axios
          .get(`${COUPON_SERVICE_APIS?.COUPON_VMS_SUB_CATEGORY?.baseURL}?category_id=${categoryIdsParam}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ICouponserviceSubCategoryResponse>) => {
            if (res.data.status) {
              setServiceSubCategory(res.data.data);
              return { status: true, message: res.data.data };
              //
            } else {
              setServiceSubCategory([]);
              return { status: false, message: [] };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            if (e.code === "ERR_BAD_REQUEST") {
              setServiceSubCategory([]);
              //   toast.error("Error while fetching List details");
            }
            if (e.status === 400) {
              setServiceSubCategory([]);
              //   toast("Product records not found");
            }

            if (e.response.status === 500) {
              setServiceSubCategory([]);
              // toast.error("Server error 500");
            }
            return { status: false, message: [] };
          });
        return response;
      } catch (e: any) {
        // toast.error("Server Error: " + e.message);
        setServiceSubCategory([]);
      }
    },
    [dispatch],
  );
  return { execute, serviceSubCategory, appendInResult };
};
